export default __webpack_public_path__ + "static/media/Satish.9591e551.svg";